export const DELIVERABLE_STATUS = 'deliverable';
export const UNDELIVERABLE_STATUS = 'undeliverable';
export const NO_MATCH_STATUS = 'no_match';
export const MISSING_UNIT_STATUS = 'deliverable_missing_unit';
export const MISSING_INFO_STATUS = 'deliverable_missing_info';
export const INCORRECT_UNIT_STATUS = 'deliverable_incorrect_unit';
export const UNNECESSARY_UNIT_STATUS = 'deliverable_unnecessary_unit';

export const NO_SUGGESTION = 'no_suggestion';
export const SUGGESTION_AVAILABLE = 'suggestion_available';
export const VERIFIED = 'verified';

export const UNDELIVERABLE_MSG = 'The address you entered is not deliverable, please edit your address.';
export const DELIVERABLE_MISSING_UNIT_MSG = 'The address you entered may be undeliverable due to a missing unit number. Please edit your address.';
export const DELIVERABLE_UNNECESSARY_UNIT_MSG = 'The address you entered may be undeliverable due to unnecessary unit info, please edit your address.';
export const DELIVERABLE_INCORRECT_UNIT_MSG = 'The address you entered may be undeliverable due to incorrect unit info, please edit your address.';

export const VERIFIED_ADDRESS = 'verified';
export const SUBTITLE_OPTIONS = 'We were not able to verify your shipping address, please choose one of the options below.';
export const SUBTITLE_NO_OPTIONS = 'The address you entered is not deliverable, please edit your address.';
export const SUGGESTION_TEXT = 'We have highlighted our suggestions in green.';
